var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTeacherApplication(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 7.55566H22.2222C22.8116 7.55566 23.3768 7.78979 23.7935 8.20654C24.2103 8.62329 24.4444 9.18852 24.4444 9.77789V25.3334C24.4444 25.9228 24.2103 26.488 23.7935 26.9048C23.3768 27.3215 22.8116 27.5557 22.2222 27.5557H8.88885C8.29948 27.5557 7.73425 27.3215 7.3175 26.9048C6.90075 26.488 6.66663 25.9228 6.66663 25.3334V9.77789C6.66663 9.18852 6.90075 8.62329 7.3175 8.20654C7.73425 7.78979 8.29948 7.55566 8.88885 7.55566H11.1111",
    stroke: "#0A80D5",
    strokeWidth: 2.22222,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8885 5.33301H12.2218C11.6082 5.33301 11.1107 5.83047 11.1107 6.44412V8.66634C11.1107 9.27999 11.6082 9.77745 12.2218 9.77745H18.8885C19.5021 9.77745 19.9996 9.27999 19.9996 8.66634V6.44412C19.9996 5.83047 19.5021 5.33301 18.8885 5.33301Z",
    stroke: "#0A80D5",
    strokeWidth: 2.22222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeacherApplication);
export default __webpack_public_path__ + "static/media/teacher-application.29dd35d9a1f3ada59be2e510528dd0b3.svg";
export { ForwardRef as ReactComponent };